<template>
  <div
    class="wf-form-step-selection"
    :class="{'wf-form-step-selection-flat': panelStyle==='flat'}"
    v-if="wftStartStages?.length > 1 && !selectedStartingStep"
  >
    <h4 class="mb-4 v-center space-between weight-400">
      Select start step for the workFlow
      <router-link
        :to="`/workflows/${wfTypeName}/?tid=${templateId}&version=${templateVersionId}`"
        target="_blank"
      >
        <button class="btn mr-3 v-center" v-overflow-tooltip="'View workflow'">
          <img
            src="~@/assets/images/icons/workflows.svg"
            class=""
            width="18px"
            height="18px"
            alt=""
          />
        </button>
      </router-link>
    </h4>
    <div class="wf-form-step-selection-list">
      <div
        class="wf-form-step-selection-item"
        v-for="stage in wftStartStages"
        :key="stage.id"
        @click="$emit('selectStartingStep', stage)"
      >
        {{ stage?.name }}
      </div>
    </div>
  </div>
  <div class="activeStep" :class="{'activeStep-flat':panelStyle === 'flat'}" v-else>
    <div class="space-between v-center my-2">
      <h3 class="weight-500 xl v-center">
        <img
          v-if="wftStartStages?.length > 1"
          src="~@/assets/images/icons/arrow-back.svg"
          width="20"
          @click="$emit('removeSelection')"
          class="mx-2"
        />
        Active Step
      </h3>
      <router-link
        :to="`/workflows/${wfTypeName}/?tid=${templateId}&version=${templateVersionId}`"
        target="_blank"
      >
        <button class="btn mr-3 v-center view-workflow-btn" v-overflow-tooltip="'View workflow'">
          <img
            src="~@/assets/images/icons/workflows.svg"
            class="mx-2"
            width="20px"
            height="20px"
            alt=""
          /></button
      ></router-link>
    </div>

    <div class="grid-3 w-100">
      <span class="label">Name </span>
      <span>:</span>
      <span class="value elipsis-text">{{ selectedStartingStep?.name }}</span>
    </div>

    <div class="grid-3 w-100">
      <span class="label">Duration </span>
      <span>:</span>
      <span class="value">{{ selectedStartingStep?.duration ?? '--' }}&nbsp;{{ this.config.DURATION_TYPE[selectedStartingStep?.duration_type] }}</span>
    </div>
    <div
      class="grid-3 w-100"
      v-if="selectedStartingStep?.core_user_group?.name"
    >
      <span class="label">Department </span>
      <span>:</span>
      <span class="value">{{
        selectedStartingStep?.core_user_group?.name ?? "--"
      }}</span>
    </div>
    <!-- user selection startrs -->
 <div v-if="showUserSelection">
 <user-selection-for-wf
        :selectedStartingStep="selectedStartingStep"
        :selectedUsers="prevInstanceusers"
        :selectedUserGroup="selectedUserGroup"
        @handleUserSelection="handleUserSelection"
      />
</div>
<!-- user selection ends -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import userSelectionForWf from '@/components/form/userSelectionForWf.vue'
import config from '@/config'

export default {
  components: {
    userSelectionForWf
  },
  name: 'workflowStartingStpSelection',
  props: {
    wftStartStages: {
      type: Array,
      default: () => []
    },
    workflowData: {
      type: Object,
      default: () => ({})
    },
    selectedStartingStep: {
      type: Object,
      default: null
    },
    wfTypeName: {
      type: String,
      default: ''
    },
    templateId: {
      type: String,
      default: ''
    },
    templateVersionId: {
      type: String,
      default: ''
    },
    selectedUserGroup: {
      type: Array,
      default: () => ([])
    },
    feature: {
      type: String,
      default: 'form'
    },
    panelStyle: {
      type: String
    }

  },
  data () {
    return {
      prevInstanceusers: [],
      config
    }
  },
  computed: {
    ...mapGetters(['isExternalCollaborator']),
    showUserSelection () {
      if (this.feature === 'tenant-invite') {
        return false
      } else if (!this.isExternalCollaborator && this.prevInstanceusers !== null) {
        return true
      }
      return false
    }
  },
  methods: {
    handleUserSelection (data) {
      this.$emit('handleUserSelection', data)
    }
  }
}
</script>
<style lang="scss" scoped>
.wf-form-step-selection {
  box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
  padding: 20px;
  background: white;
  border-radius: 6px;
  margin: 1px;
  &-flat{
padding: 0;
box-shadow: none;
  }
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin-top: 25px;
  }
  &-item {
    position: relative;
    border: 1px solid rgba(37, 99, 235, 0.35);
      padding: 6px 17px;
    border-radius: 10px;
    background: linear-gradient(135deg, rgba(147, 197, 253, 0.55), rgba(59, 130, 246, 0.2));
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.2px;
    color: #0f172a;
    cursor: pointer;
    transition: transform 180ms ease, box-shadow 200ms ease, border-color 200ms ease, background 200ms ease, color 200ms ease;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
    animation: wfStepPop 280ms ease both;
    user-select: none;
    will-change: transform;
  }
  &-item::after {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 10px;
    background: radial-gradient(80% 120% at 0% 0%, rgba(255, 255, 255, 0.45), rgba(255, 255, 255, 0));
    opacity: 0;
    transition: opacity 200ms ease;
    pointer-events: none;
  }
  &-item:hover {
    transform: translateY(-2px) scale(1.02);
    border-color: rgba(37, 99, 235, 0.7);
    box-shadow: 0 10px 22px rgba(15, 23, 42, 0.18);
    color: #0b1020;
  }
  &-item:hover::after {
    opacity: 1;
  }
  &-item:active {
    transform: translateY(0) scale(0.98);
    box-shadow: 0 4px 10px rgba(15, 23, 42, 0.16);
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.45), rgba(147, 197, 253, 0.35));
  }
}
.activeStep{
      display: flex;
      flex-direction: column;
      gap: 20px;
      box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.25);
      padding: 20px;
      background: white;
      border-radius: 6px;
      margin: 2px 4px 4px 4px;
      &-flat {
        box-shadow: none;
        padding: 0px;
      }
      & .view-workflow-btn{
     padding: 5px 0px;
      }

    }
.grid-3{
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  align-items: center;
  & .label{

  }
  & .value{

  }
}

@keyframes wfStepPop {
  from {
    opacity: 0;
    transform: translateY(6px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wf-form-step-selection-item {
    animation: none;
    transition: none;
  }
}
</style>
